import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { SEARCH_QUERY_ID_PARAM } from '@xing-com/crate-jobs-constants';

export const useSearchQueryId = (): string | null => {
  const { getSearchParameter } = useSearchParameter();
  return getSearchParameter(SEARCH_QUERY_ID_PARAM);
};
